import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

require('./bringoz-numeric-widget.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-numeric-widget',
  templateUrl: './bringoz-numeric-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozNumericWidgetComponent  {

  @Input() value: number | string;
  @Input() color: string;
  @Input() size: number;
  @Output() clickEvent = new EventEmitter<null>();

  constructor() {
  }

  isNumeric(value: number | string): boolean {
    return typeof value === 'number' && isFinite(value);
  }

}
